// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"0801d85c","321":"20e167ea","391":"5e541693","636":"3fc61f80","840":"09adc563","931":"2df32b3d","999":"a9913251"}[chunkId] + ".chunk.js";
};